import React, { useEffect, useState } from 'react'
import { getAllTimezones } from 'countries-and-timezones'
import { ReactSelectOption, Select, SelectProps } from './select/Select'

import { orderBy } from 'lodash'
import dayjs from 'shared/dayjs'

const createTimezonesWithoutCountries = () => {
  const sortedTimezones = orderBy(getAllTimezones(), 'utcOffset', 'desc')

  return sortedTimezones.reduce<ReactSelectOption[]>((options, value) => {
    options.push({
      label: `(GMT${value.dstOffsetStr || value.utcOffsetStr}) ${value.name}`,
      value: value.name
    })

    return options
  }, [])
}

const TIMEZONES_OPTIONS = Object.freeze(createTimezonesWithoutCountries())
const TIMEZONES_MAP = Object.freeze(
  TIMEZONES_OPTIONS.reduce<Record<string, ReactSelectOption>>(
    (optionsMap, option) => {
      optionsMap[option.value] = option

      return optionsMap
    },
    {}
  )
)

type SelectTimezoneProps = Omit<SelectProps, 'value' | 'onChange'> & {
  value?: string | null
  onChange: (value: string | null) => void
  guess?: boolean
}

const SelectTimezone = ({
  value,
  onChange,
  guess = false,
  ...rest
}: SelectTimezoneProps) => {
  const [localValue, setLocalValue] = useState(value || '')
  const selectedTimezone = TIMEZONES_MAP[localValue]

  useEffect(() => {
    if (!guess || value) return

    const guessed = dayjs.tz.guess()

    onChange && onChange(guessed)
    setLocalValue(guessed)
  }, [])

  return (
    <Select
      {...rest}
      options={TIMEZONES_OPTIONS}
      value={selectedTimezone}
      onChange={(option) => {
        if (option) {
          setLocalValue(option.value)
          onChange && onChange(option.value)
        } else {
          setLocalValue('')
          onChange && onChange(null)
        }
      }}
    />
  )
}

export default SelectTimezone
